<template>
	<div class="c-ad-foot" id="c-ad-foot">
		<ins class="adsbygoogle"
		style="display:inline-block;width:970px;height:90px"
		data-ad-client="ca-pub-1949121304889987"
		data-ad-slot="7586846034"></ins>
	</div>
</template>

<script>

export default {

	name: "c-ad-foot",

	created (){
		var adsbygoogle;

		$("<script>", {
			src: "//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"
		})
		.appendTo("head");

		adsbygoogle = window.adsbygoogle = window.adsbygoogle || []; 
		adsbygoogle.push({}); 
	}
}

</script>


// WEBPACK FOOTER //
// ad-foot.vue?d4f8afb4